<script>
  import 'codemirror/lib/codemirror.css'
  import '@toast-ui/editor/dist/toastui-editor.css'

  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  import { uploadImages } from '../../../services/strapiRestService'
  import { BASE_URL } from '../../constants/constants.js'

  let editor
  export let initialValue = ''

  const initEditor = async (node) => {
    const Editor = (await import('@toast-ui/editor')).default
    let options = {
      initialEditType: 'wysiwyg',
      height: '300px',
      initialValue: initialValue,
      hideModeSwitch: true,
      el: node,
      toolbarItems: [
        'heading',
        'bold',
        'italic',
        'strike',
        'divider',
        'hr',
        'quote',
        'divider',
        'ul',
        'ol',
        'task',
        'indent',
        'outdent',
        'divider',
        'table',
        'image',
        'link'
      ],
      hooks: {
        addImageBlobHook: function (blob, callback) {
          uploadImages(blob).then((res) => {
            callback(`${BASE_URL + res[0].url}`, '')
          })
        },
      },
    }
    editor = new Editor(options)

    editor.on('change', () => {
      dispatch('change', {
        value: editor.getMarkdown(),
        editor: editor,
      })
    })

    return {
      destroy() {
        editor.remove()
      },
    }
  }
</script>

<div use:initEditor />
